/* eslint-disable react-hooks/rules-of-hooks */
// TODO: https://tasks.awstcprojects.com/browse/PLATFORM-4620 - remove above disable
import {
  MessageFormatArgs,
  LocalizationHook,
  LocalizationHookContext,
  LocalizationFallbackFactory,
  useLogger,
} from "@amzn/xb-hooks";
import { useBundle } from "@amzn/react-arb-tools";
import { ReactNode } from "react";

const localizationHook: LocalizationHook = (namespace: string, fallbackFactory?: LocalizationFallbackFactory) => {
  const [bundle, stringsLoading] = useBundle(namespace);
  const { log } = useLogger();
  const fallback: LocalizationFallbackFactory = fallbackFactory ?? ((key, isLoading) => (isLoading ? "" : key));
  return [
    (id: string, ...args: MessageFormatArgs[]) => {
      try {
        return bundle?.formatMessage(id, ...args);
      } catch (e) {
        log.error(`Failed to format message: ${id}`);
        return fallback(id, stringsLoading);
      }
    },
    stringsLoading,
  ];
};

export const LocalizationHookProvider = ({ children }: { children: ReactNode }) => (
  <LocalizationHookContext.Provider value={localizationHook}>{children}</LocalizationHookContext.Provider>
);
